import { configureStore } from "@reduxjs/toolkit";
import providerOfferAllReducer from "../slices/providerOfferAllSlice";

// Create Redux store
export const store = configureStore({
  reducer: {
    providerOfferAll: providerOfferAllReducer,
  },
});
